export default "__VITE_ASSET__Bx45sFwb__"